import { render, staticRenderFns } from "./PostComments.vue?vue&type=template&id=08d76a42&"
import script from "./PostComments.vue?vue&type=script&lang=js&"
export * from "./PostComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports